import { post, get, baseURL } from "@/utils/request";

// Login
export const login = (data: any) => post(`/auth/login`, data);

// Register
export const register = (data: any) => post(`/auth/register`, data);

// User info
export const getUserInfo = () => get(`/user/info`, {});

// PWA Reward API
export const PWARewardAPI = (data : any) => post(`/pwaReward/claim`, data);

// Add user favorites
export const addUserFavorites = (data: any) => post(`/favoriteGames/add`, data);

// Logout
export const logOut = () => post(`/auth/logout`);

//getCaptcha
export const getCaptchaCode = () => get(`/auth/code`);

//getsmsOTPCode
export const getSmsOtpCode = (param : any) => post(`/signIn/sendSmsCode?phoneNo=${param.phone}&areaCode=55`);

//getEmailOTPCode
export const getEmailOtpCode = (param : any) => post(`/signIn/sendEmailCode?email=${param.email}&login_account=${param.phone}`);

//getsmsOTPCode
export const getWhatsappOtpCode = (param : any) => post(`/signIn/sendWhatsAppCode?whatsAppNo=${param.phone}&areaCode=55`);

